import { memo } from 'react'
import { Typography } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'

import { ACCEPTED_FILE_EXTENSIONS, MAX_MB } from '../../../../config/settings/constants'
import { ATTACHMENT_CATEGORIES } from '../../Cfmp.constants'
import { AttachedFiles, FileUploadInfo } from '../../Cfmp.styles'
import { CfmpFormAttachmentsCategory } from './CfmpFormAttachmentsCategory'

/**
 * The CfmpFormAttachments component.
 */
export const CfmpFormAttachments = memo(
  ({ attachedFiles = [], errors = {}, isDisabled = false, onAdd, onRemove }) => (
    <AttachedFiles direction="column" spacing={3}>
      <FileUploadInfo direction="column" spacing={0.5}>
        <Typography fontWeight="bold" variant="body1">
          Adjuntar archivos
        </Typography>

        <Typography color="black3" variant="body2">
          Se admiten archivos con un peso máximo de {MAX_MB}MB. Formatos permitidos:{' '}
          {ACCEPTED_FILE_EXTENSIONS.join(', ')}.
        </Typography>
      </FileUploadInfo>

      {ATTACHMENT_CATEGORIES.map(category => (
        <CfmpFormAttachmentsCategory
          category={category}
          error={errors[category.id] || ''}
          files={attachedFiles.filter(file => file.categoryId === category.id)}
          isDisabled={isDisabled}
          key={category.id}
          onAdd={onAdd}
          onRemove={onRemove}
        />
      ))}
    </AttachedFiles>
  )
)

CfmpFormAttachments.displayName = 'CfmpFormAttachments'

CfmpFormAttachments.propTypes = {
  attachedFiles: PropTypes.array,
  errors: PropTypes.object,
  isDisabled: PropTypes.bool,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
}
